//NavSeconday handles all the "tab" changing logic such as what is used in ProfessionalLearning.cshtml & Account/MyAccount.cshtml.
const navContents = $(".nav-left").html();
let mobileLeftNav;
let allowSwitchTabs;
const htmlBody = $('html, body');


if (typeof allowSwitchTabs === 'undefined') {
    allowSwitchTabs = true
}

function toggleActiveNavLink(currentLink = $('#subLocationNav .nav-link').first().attr('data-target')) {
    $('#subLocationNav .nav-link.active').removeClass('active');
    $('#subLocationNav .nav-link[data-target=' + currentLink + ']').addClass('active');
}
function toggleActiveNavContent(currentLink = $(".tab-content").first().attr('id')) {
    $(".tab-content").hide();
    
    $(".tab-content#" + currentLink).show();
} 

/*Please Note; if you are doing deferred loading (aka, ajax calls to load partials content sections).
 * You will need to call this function each time you load a new section so that the "mobile-nav" 
 * will properly work with that new section.
 */ 
export function loadMobileNav() {
    $(".page-header").each(function () {
        if (!$(this).find(".mobile-left-nav").length) {
            $(this).append('<div class="mobile-left-nav">' + navContents + '</div>');
        }
    });
    mobileLeftNav = $(".mobile-left-nav");

    const currentHash = location.hash.substr(1);
    if (currentHash) {
        toggleActiveNavLink(currentHash);
        toggleActiveNavContent(currentHash);
    }
    else {
        toggleActiveNavLink();
        toggleActiveNavContent();
    }

    mobileLeftNav.on('click', function () {
        mobileLeftNav.removeClass('active');
    });

    //Ensure we don't stack up event bindings.
    $(".page-header .heading-row").off('click');

    //Bind fresh single instance bindings. 
    $(".page-header .heading-row").on('click', function (e) {
        e.stopPropagation();
        $(this).siblings(mobileLeftNav).toggleClass('active');  
    });  
} 

$(function () {
    loadMobileNav(); 
});

$(".mobile-left-nav a").on('click', function () {
    mobileLeftNav.removeClass('active');
});
 
$("#main").on('click', '#subLocationNav .nav-link, .mobile-left-nav .nav-link', function () {
    const currentLink = $(this).data('target');
    // switch tabs
    if (allowSwitchTabs === true) {
        toggleActiveNavLink(currentLink);
        toggleActiveNavContent(currentLink);
        // Instructor Tools callback for DataTables recalc method
        const callback = $(this).data('callback');
        const func = eval(callback);
        if (typeof func === 'function') {
            func();
        }
    }
});

function resize() {
    $.fn.dataTable.tables({ visible: true, api: true })
        //@ts-ignore: next-line
        .columns.adjust()
        //@ts-ignore: next-line
        .responsive.recalc();
}

$(".page-header .heading-row").on('click', function () {
    mobileLeftNav.toggleClass('active');
});
//# sourceMappingURL=NavSecondary.js.map
